/* eslint space-in-parens: 0 */
import styled, { keyframes } from 'styled-components'
import { theme } from '../../styles/theme'

interface IInfoProps {
  isShowing: boolean;
}

export const Container = styled.div`
  position: absolute;
  bottom: 30px;
  left: 0;
  right: 0;
  z-index: 999999;

  display: flex;
  align-items: center;
  justify-content: center;
`

const starting = keyframes`
  0% {
    transform: scale(0.5) translate(0px, 50px);
    opacity: 0.3;
  }
  100% {
    transform: scale(0.5) translate(0px, 50px);
    opacity: 0.3;
  }
`

export const Info = styled.div<IInfoProps>`
  padding: 10px 15px;

  background: ${theme.colors.green};
  color: ${theme.colors.mainBg};
  font-size: ${theme.font.sizes.xsmall};
  font-weight: ${theme.font.medium};
  border-radius: ${theme.border.normal};

  animation: ${starting} linear;
  /* transform: scale(0.5) translate(0px, 50px);
  opacity: 0.3;
  transition: opacity 5s; 
  transform: scale(1) translate(0px, 0px);
  opacity: 1; */

  display: ${({ isShowing }) => (isShowing ? 'flex' : 'none' )};
`
